<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button
            v-if="from === 'answerSummary'"
            @click="modalController.dismiss()"
          >
            <ion-icon
              :src="require('@lib/assets/icons/icon_zurueck.svg')"
              slot="start"
            ></ion-icon>
          </ion-button>
          <back-button
            v-else
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <!-- <div
          class="c-header u-bg-yellow -contain"
          :style="{
            'background-image':
              'url(' + require('@/assets/img/header/icon_pharma.svg') + ')',
          }"
        >
          <img
            class="c-header__logo"
            src="@arag/assets/img/medicalcontact_logo.png"
            width="150"
          />
        </div> -->
        <Header
          class="u-bg-yellow -contain"
          headline="Bessere Lebensqualität bei Herzerkrankungen und/oder Diabetes&nbsp;II."
          :image="require('@/assets/img/header/icon_pharma.svg')"
          hideButton
        />
        <p class="ion-padding-top">
          <b v-if="from === 'answerSummary'"
            >Sie leiden an einer Herzkrankheit und/oder Diabetes II und möchten
            Ihre Lebensqualität verbessern?</b
          >
          <b v-else
            ><span class="ion-hide-lg-up"
              >Bessere Lebensqualität bei Herzerkrankungen und/oder Diabetes
              II.</span
            >
            Holen Sie sich Unterstützung für den richtigen Umgang mit Ihrer
            Erkrankung.
          </b>
        </p>
        <p>
          Die Coaches von MedicalContact
          <template v-if="from === 'answerSummary'"
            >unterstützen Sie beim richtigen Umgang mit Ihrer Erkrankung
            und</template
          >
          helfen Ihnen mit gesundheitsfördernden Maßnahmen:
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_ernaehrung.svg')"
              />
            </ion-col>
            <ion-col> Ernährung </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_koerpliche_aktivitaet.svg')
                "
              />
            </ion-col>
            <ion-col> Körperliche Aktivität </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_vorbeugung_folgeerkrankungen.svg')
                "
              />
            </ion-col>
            <ion-col> Vorbeugung von Folgeerkrankungen </ion-col>
          </ion-row>
        </p>
        <!-- <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_schrittzaehler-purple.svg')
                "
              />
            </ion-col>
            <ion-col>
              Medizinische Hilfsmittel wie Schrittzähler, Blutzucker- oder
              Blutdruckmessgerät (bei Bedarf; kostenlose Bereitstellung)
            </ion-col>
          </ion-row>
        </p> -->
        <!-- <div class="c-line"></div> -->
        <p>
          Ein speziell ausgebildeter Coach von MedicalContact erstellt in einem
          telefonischen Einführungsgespräch mit Ihnen gemeinsam die Inhalte
          Ihres Coachings.
          <!-- Bei Bedarf werden auch medizinische Hilfsmittel wie
          Schrittzähler, Blutzucker- oder Blutdruckmessgerät kostenlos zur
          Verfügung gestellt. -->
        </p>
        <p>
          Sie haben folgende Möglichkeiten: Signieren Sie die Teilnahmeerklärung
          und drucken Sie diese aus, unterschreiben Sie sie und laden Sie die
          Teilnahmeerklärung wieder hoch in Ihren Roodie.Safe. Anschließend
          geben Sie diese für Medical Contact frei. Oder senden Sie das Formular
          unterzeichnet per Post an Medical Contact.
        </p>
        <!-- <p>
          <a href="#" @click.prevent="openKostenerstattungModal"
            ><u>18 Monate kostenlos für ARAG-Kunden mit Vollversicherung!</u></a
          >
        </p>
        <p>
          <ion-row class="ion-align-items-center">
            <ion-col>
              <a href="#" @click.prevent="openAnleitungMedicalContact()"
                ><u>So einfach geht's</u></a
              >
            </ion-col>
          </ion-row>
        </p> -->
        <!-- <img
          class="ion-margin-vertical"
          src="@arag/assets/img/medicalcontact_logo.png"
          width="250"
        /> -->
        <ion-grid class="ion-no-padding">
          <ion-row class="ion-align-items-center c-cta">
            <ion-col>
              <ion-button
                @click="openFormCoaching"
                class="u-sm-block -lg-large"
                >{{
                  from === "answerSummary"
                    ? "Coaching nutzen"
                    : "Teilnahmeerklärung anfordern"
                }}</ion-button
              >
            </ion-col>
            <ion-col v-if="from === 'answerSummary'">
              <ion-button
                @click="modalController.dismiss()"
                class="u-sm-block -lg-large"
                >Beenden</ion-button
              >
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-row class="ion-margin-top">
          <ion-col>
            <div
              class="c-nugget u-bg-yellow"
              @click="openAnleitungMedicalContact()"
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/icon_roodie_call.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">So funktioniert's</div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget u-bg-yellow"
              @click="openKostenerstattungModal"
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/icon_roodie_costs.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">18 Monate kostenlos*</div>
            </div>
          </ion-col>
        </ion-row>
        <!-- <ion-row class="ion-padding-top">
          <ion-col size="auto">
            <ion-icon :src="require('@lib/assets/icons/info.svg')" />
          </ion-col>
          <ion-col>
            <ion-text color="primary" class="u-xsmall">
              Am Ende erhalten Sie einen Behandlungsplan und bei Bedarf eine
              Überweisung, ein Rezept oder eine
              Arbeitsunfähigkeitsbescheinigung.
            </ion-text>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack, helpCircle } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  IonBackButton,
  modalController,
  // IonText,
} from "@ionic/vue";
import KostenerstattungModal from "@/components/KostenerstattungMedicalContactModal";
import FormCoaching from "@/components/FormCoaching";
import AnleitungMedicalContact from "@/views/AnleitungMedicalContact";
import Header from "@/components/Header";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    // IonText,
    Header,
    IonBackButton,
  },
  props: {
    from: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      modalInstance: null,
    };
  },
  async mounted() {
    this.modalInstance = await modalController.getTop();
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
    async openFormCoaching() {
      const modal = await modalController.create({
        component: FormCoaching,
        componentProps: {
          from: this.from,
        },
      });
      modal.onWillDismiss().then((result) => {
        if (result.data?.isSubmitted) {
          if (this.from === "answerSummary") {
            this.modalInstance.dismiss();
          } else {
            this.$router.push({ name: "home" });
          }
        }
      });
      return modal.present();
    },
    async openAnleitungMedicalContact() {
      const modal = await modalController.create({
        component: AnleitungMedicalContact,
        componentProps: {
          from: this.from,
        },
      });
      return modal.present();
    },
  },

  setup() {
    return {
      chevronBack,
      helpCircle,
      modalController,
    };
  },
};
</script>

<style lang="scss" scoped></style>
